var IconStyles;
(function (IconStyles) {
    IconStyles["Solid"] = "fas";
    IconStyles["Regular"] = "far";
    IconStyles["Light"] = "fal";
    IconStyles["Duotone"] = "fad";
    IconStyles["Brands"] = "fab";
})(IconStyles || (IconStyles = {}));
export default IconStyles;
